export enum FeatureToggleIdentifier {
  ENABLE_ADOBE_ANALYTICS = "ENABLE_ADOBE_ANALYTICS",
  SHOW_PLAYGROUND = "SHOW_PLAYGROUND",
  ENABLE_INTERNATIONAL_PHONE_NUMBER = "ENABLE_INTERNATIONAL_PHONE_NUMBER",
  ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION = "ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION",
  ENABLE_INTERCARE_MEDICAL_ASSISTANCE = "ENABLE_INTERCARE_MEDICAL_ASSISTANCE",
  ENABLE_INTERNATIONAL_PHONE_NUMBER_UG = "ENABLE_INTERNATIONAL_PHONE_NUMBER_UG",
  ENABLE_FACE_SCAN_PRODUCT_RULES = "ENABLE_FACE_SCAN_PRODUCT_RULES",
  ENABLE_CHAT_BOT = "ENABLE_CHAT_BOT",
  ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION = "ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION",
  ENABLE_THIRD_PARTY_AUTHENTICATION = "ENABLE_THIRD_PARTY_AUTHENTICATION",
  ENABLE_PATHOLOGY_PANELS = "ENABLE_PATHOLOGY_PANELS",
  ENABLE_MAINTENANCE_MODE = "ENABLE_MAINTENANCE_MODE",
  ENABLE_PROMO_CODES = "ENABLE_PROMO_CODES",
  ENABLE_DEPENDANT_SERVICE_OFFERING = "ENABLE_DEPENDANT_SERVICE_OFFERING",
  ENABLE_FORCE_APP_UPDATE = "ENABLE_FORCE_APP_UPDATE",
  ENABLE_VOUCHER_REDEMPTION = "ENABLE_VOUCHER_REDEMPTION",
  ENABLE_DOC_MED_BUNDLES = "ENABLE_DOC_MED_BUNDLES",
  ENABLE_ENHANCED_PAYMENT_OPTIONS = "ENABLE_ENHANCED_PAYMENT_OPTIONS",
  ENABLE_ONE_VOUCHER_REDEMPTION = "ENABLE_ONE_VOUCHER_REDEMPTION",
  ENABLE_CONSULTATION_PAYMENT_HISTORY = "ENABLE_CONSULTATION_PAYMENT_HISTORY",
  ENABLE_DISCOUNT_VOUCHERS = "ENABLE_DISCOUNT_VOUCHERS",
  ENABLE_UNIFIED_CARE = "ENABLE_UNIFIED_CARE",
  ENABLE_SINGLE_CONSULTATION_ID = "ENABLE_SINGLE_CONSULTATION_ID",
  ENABLE_DEBUG_CONSOLE_LOGS = "ENABLE_DEBUG_CONSOLE_LOGS",
  ENABLE_TRENDED_VITALS = "ENABLE_TRENDED_VITALS",
  ENABLE_API_MAINTENANCE_MODE = "ENABLE_API_MAINTENANCE_MODE",
}

// Flags are captured when the module loads, matching application startup behavior.
const featureToggles: Record<string, boolean> = Object.assign(
  Object.create(null),
  {
    [FeatureToggleIdentifier.ENABLE_ADOBE_ANALYTICS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_ADOBE_ANALYTICS === "true",
    [FeatureToggleIdentifier.SHOW_PLAYGROUND]:
      import.meta.env.VITE_APP_FEATURE_SHOW_PLAYGROUND === "true",
    [FeatureToggleIdentifier.ENABLE_INTERNATIONAL_PHONE_NUMBER]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_INTERNATIONAL_PHONE_NUMBER ===
      "true",
    [FeatureToggleIdentifier.ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION]:
      import.meta.env
        .VITE_APP_FEATURE_ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION === "true",
    [FeatureToggleIdentifier.ENABLE_INTERCARE_MEDICAL_ASSISTANCE]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_INTERCARE_MEDICAL_ASSISTANCE ===
      "true",
    [FeatureToggleIdentifier.ENABLE_INTERNATIONAL_PHONE_NUMBER_UG]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_INTERNATIONAL_PHONE_NUMBER_UG ===
      "true",
    [FeatureToggleIdentifier.ENABLE_FACE_SCAN_PRODUCT_RULES]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_FACE_SCAN_PRODUCT_RULES ===
      "true",
    [FeatureToggleIdentifier.ENABLE_CHAT_BOT]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_CHAT_BOT === "true",
    [FeatureToggleIdentifier.ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION]:
      import.meta.env
        .VITE_APP_FEATURE_ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION === "true",
    [FeatureToggleIdentifier.ENABLE_THIRD_PARTY_AUTHENTICATION]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_THIRD_PARTY_AUTHENTICATION ===
      "true",
    [FeatureToggleIdentifier.ENABLE_PATHOLOGY_PANELS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_PATHOLOGY_PANELS === "true",
    [FeatureToggleIdentifier.ENABLE_MAINTENANCE_MODE]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_MAINTENANCE_MODE === "true",
    [FeatureToggleIdentifier.ENABLE_PROMO_CODES]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_PROMO_CODES === "true",
    [FeatureToggleIdentifier.ENABLE_DEPENDANT_SERVICE_OFFERING]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_DEPENDANT_SERVICE_OFFERING ===
      "true",
    [FeatureToggleIdentifier.ENABLE_FORCE_APP_UPDATE]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_FORCE_APP_UPDATE === "true",
    [FeatureToggleIdentifier.ENABLE_VOUCHER_REDEMPTION]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_VOUCHER_REDEMPTION === "true",
    [FeatureToggleIdentifier.ENABLE_DOC_MED_BUNDLES]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_DOC_MED_BUNDLES === "true",
    [FeatureToggleIdentifier.ENABLE_ENHANCED_PAYMENT_OPTIONS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_ENHANCED_PAYMENT_OPTIONS ===
      "true",
    [FeatureToggleIdentifier.ENABLE_ONE_VOUCHER_REDEMPTION]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_ONE_VOUCHER_REDEMPTION === "true",
    [FeatureToggleIdentifier.ENABLE_CONSULTATION_PAYMENT_HISTORY]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_CONSULTATION_PAYMENT_HISTORY ===
      "true",
    [FeatureToggleIdentifier.ENABLE_DISCOUNT_VOUCHERS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_DISCOUNT_VOUCHERS === "true",
    [FeatureToggleIdentifier.ENABLE_UNIFIED_CARE]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_UNIFIED_CARE === "true",
    [FeatureToggleIdentifier.ENABLE_SINGLE_CONSULTATION_ID]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_SINGLE_CONSULTATION_ID === "true",
    [FeatureToggleIdentifier.ENABLE_DEBUG_CONSOLE_LOGS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_DEBUG_CONSOLE_LOGS === "true",
    [FeatureToggleIdentifier.ENABLE_TRENDED_VITALS]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_TRENDED_VITALS === "true",
    [FeatureToggleIdentifier.ENABLE_API_MAINTENANCE_MODE]:
      import.meta.env.VITE_APP_FEATURE_ENABLE_API_MAINTENANCE_MODE === "true",
  }
);

/** Returns the startup flag value. Unknown identifiers have no configured value. */
export function isFeatureEnabled(
  featureIdentifier: FeatureToggleIdentifier | string
): boolean {
  return featureToggles[featureIdentifier];
}
